import { PowerBiReport } from './models/powerbi-embed.model';

export const DATA_QUALITY_MODULE_KEY = 100108;
export const POWER_BI_CARD_ICON = 'assets/svgIcons/powerbi.svg';

export const POWER_BI_MODULE_FOLDERS: Record<number, string> = {
  [DATA_QUALITY_MODULE_KEY]: 'Data Quality',
};

export function getPowerBiFolderForModule(moduleKey: number): string | undefined {
  return POWER_BI_MODULE_FOLDERS[Number(moduleKey)];
}

export function mapPowerBiReportToDashboardCard(report: PowerBiReport): Record<string, unknown> {
  return {
    dashboard_nm: report.name,
    hide_flg: 'N',
    access_flg: 'Y',
    hist_access_flg: 'H',
    isPowerBiReport: true,
    reportId: report.id,
    active_image: POWER_BI_CARD_ICON,
  };
}
